module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAALVBMVEVHcExwo99ypeBypeBypd9ypd9zptxypuBypd9ypuFypeBzpd9ypd9ypN9ypd+hq5ePAAAADnRSTlMAHnX2xlYO5Lkr2aecpkHka08AAADBSURBVBjTY2BgYGDUKLZqEmAAA8Z774DgLYQX/A4MTEFspndQoADkxME4T4E67MAsz3XvHgsw8ILZzwOk3r3bwCAH5ripMq5795BBD8R+ksAUMO/dI4Y+sAQDg6rfuxcMdWAJBoZ0oEYGO4gEm9+7d49BHJBEyjsQpw4uAVTW9+7VAYgE0AC9d4/mQCSARsu9e8p5ACwBtJT73UuGOWAJoHMY7R5O1QKzgQ5F8QKq51C8zcC4D8R+DQsejWJzcFABAK01pWu2i2G3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/Pencil_black_gross_tool@2x.png
// module id = J+ec
// module chunks = 69